import React from "react";

const RevisionSectionNavigator = ({
  currentSection
}) => {
  return (
    <div className="mb-3 mt-2">
      <h2 key={currentSection.title} 
        className="display-4 font-weight-bold text-white">
        {currentSection.title}
      </h2>
    </div>
  );
};

export default RevisionSectionNavigator;